import { useContext, useEffect } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

// Variables del tema (styles/color-variables.css) que toman el color del estudio
const BRAND_VARIABLES = [
    '--btn-primary-bg',
    '--btn-primary-hover',
    '--btn-outline-border',
    '--btn-outline-text',
    '--btn-outline-hover-bg',
    '--text-primary',
    '--link-color',
    '--link-hover',
    '--breadcrumb-link',
    '--input-border-focus',
    '--input-label'
];

const isHexColor = (value?: string | null) => !!value && /^#[0-9a-fA-F]{6}$/.test(value);

/**
 * Aplica la marca del estudio (white-label) a la interfaz: si el usuario
 * pertenece a un estudio, o es cliente de uno, con personalización de marca,
 * los colores del tema pasan a ser los del estudio. Sin marca propia vuelve
 * a los de Monere. No renderiza nada.
 */
const BrandingApplier = () => {
    const { auth } = useContext(AuthContext);
    const branding = auth?.branding;

    useEffect(() => {
        const root = document.documentElement;
        const primary = branding?.primary_color;
        const secondary = branding?.secondary_color;

        if (!branding?.is_white_label || !isHexColor(primary) || !isHexColor(secondary)) {
            BRAND_VARIABLES.forEach((variable) => root.style.removeProperty(variable));
            return;
        }

        root.style.setProperty('--btn-primary-bg', `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`);
        root.style.setProperty('--btn-primary-hover', `linear-gradient(135deg, ${secondary} 0%, ${primary} 100%)`);
        root.style.setProperty('--btn-outline-border', primary!);
        root.style.setProperty('--btn-outline-text', primary!);
        root.style.setProperty('--btn-outline-hover-bg', primary!);
        root.style.setProperty('--text-primary', primary!);
        root.style.setProperty('--link-color', secondary!);
        root.style.setProperty('--link-hover', primary!);
        root.style.setProperty('--breadcrumb-link', secondary!);
        root.style.setProperty('--input-border-focus', secondary!);
        root.style.setProperty('--input-label', primary!);

        return () => BRAND_VARIABLES.forEach((variable) => root.style.removeProperty(variable));
    }, [branding?.is_white_label, branding?.primary_color, branding?.secondary_color]);

    return null;
};

export default BrandingApplier;
